/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {ConfigSectionComponent} from "@app/models/components/config-section.component";
import {RegistryContexts} from "@app/models/constants/registry-constants";
import {StoreAction} from "@trec/components/store";
import {Observable, of} from "rxjs";

@Component({
  selector: "c3-config-physical-activity",
  templateUrl: "./config-physical-activity.component.html",
  styleUrls: ["./config-physical-activity.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ConfigPhysicalActivityComponent extends ConfigSectionComponent {
  loading$: Observable<boolean> = of(false);
  // @Select(hasActionsExecuting([...])) loading$: Observable<boolean>;

  @Input()
  context: RegistryContexts[];

  get touched$(): Observable<boolean> {
    return of(false);
  }
  get valid$(): Observable<boolean> {
    return of(true);
  }

  prepareSaveDataAction(): StoreAction | StoreAction[] | null {
    return null;
  }

  resetTouched(): void { }
}
